import React from 'react';

function useOutsideClick(
  elementRef: React.RefObject<any>,
  onOutsideClick: (event: any) => void
) {
  const handleOutsideClick = React.useRef(onOutsideClick);
  handleOutsideClick.current = onOutsideClick;

  React.useEffect(() => {
    function handleClickOutside(event: Event) {
      if (elementRef.current && !elementRef.current.contains(event.target)) {
        handleOutsideClick.current(event);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [elementRef]);
}

const eventName = 'resize';
function useScreenResize(maxWidth: string) {
  const [isMatch, setIsMatch] = React.useState(false);

  const handleResizeEvent = React.useCallback(() => {
    const media = window.matchMedia(`(max-width: ${maxWidth})`);
    setIsMatch(media.matches);
  }, [maxWidth]);

  React.useEffect(() => {
    handleResizeEvent();
    window.addEventListener(eventName, handleResizeEvent);
    return () => {
      window.removeEventListener(eventName, handleResizeEvent);
    };
  }, [handleResizeEvent]);

  return {isMatch};
}

export {useOutsideClick, useScreenResize}